module.exports = __webpack_public_path__ + "static/img/synthe4.70b2f96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/synthe4.png
// module id = XSFX
// module chunks = 2